import defaultState from '../../secondary-button/light-gray/background/default';

export default defaultState;
